/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Role_ColumnInputs */



/**
* | output |
* | --- |
* | "Role column (optional)" |
*
* @param {Team_Manager_Import_Role_ColumnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_role_column = /** @type {((inputs?: Team_Manager_Import_Role_ColumnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Role_ColumnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Colonne rôle (facultatif)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rollenspalte (optional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colonna ruolo (facoltativa)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Столбец роли (необязательно)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Columna de rol (opcional)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("角色列（可选）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("役割の列（任意）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("भूमिका कॉलम (वैकल्पिक)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Coluna de função (opcional)")
	return /** @type {LocalizedString} */ ("Role column (optional)")
});